(function ($) {

    $(document).ready(function () {
      setTimeout(() => {
        $('.template-cart .gs__form-options-wrapper, .template-cart .cart__checkout').addClass('vissble_tab');
      }, 5000);
      $(document).on('click', 'input[name="attributes[Bouquets-datepicker]"]', function () {
          const flatpickrInstance = this._flatpickr;
          if (!flatpickrInstance) return;
          const calendarContainer = flatpickrInstance.calendarContainer;
          const todayEl = $(calendarContainer).find('.flatpickr-day.today');
          const todayDateStr = todayEl.attr('aria-label'); // e.g., "2025-7-20"
        
          if (todayDateStr) {
              const date = new Date(todayDateStr);
              if (date.getDay() === 6) { // 6 = Saturday
                todayEl.addClass('is_saturday');
                // Add 2 days to the current date
                date.setDate(date.getDate() + 2);
                // Format next_day to match the flatpickr `aria-label` (YYYY-MM-DD)
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1);
                const day = String(date.getDate());
                const formattedNextDay = `${year}-${month}-${day}`;
                // Add classes to the matching date
                $('[aria-label="' + formattedNextDay + '"]').addClass('disabled flatpickr-disabled');
              }
          }
      });

     
        function scrollToActiveItemIfNotInView() {
            const activeItem = $(".frblog-tab-main-wrapper .frblog-tab-container .frblog-tabs-header .frblog-tab-button.active");
            if (activeItem.length) {
                const activeItemRect = activeItem[0].getBoundingClientRect();
                const container = $(".tab-head-slider")[0]; // The container with the slider
                const containerRect = container.getBoundingClientRect();
                // Check if the active item is fully within the container's visible area
                const isFullyInView =
                    activeItemRect.left >= containerRect.left &&
                    activeItemRect.right <= containerRect.right;
                if (!isFullyInView) {
                    const activeIndex = activeItem.index();
                    tab_head_slider.slideTo(activeIndex); // Scroll directly to the active item's index
                }
            }
        }
        // Trigger scrolling on page load
        scrollToActiveItemIfNotInView();
        // Trigger scrolling when a user clicks on a tab
        $(".frblog-tab-button").on("click", function () {
            setTimeout(scrollToActiveItemIfNotInView, 100); // Delay to ensure class updates are applied
        });

        // Check if .frblog-tab-main-wrapper exists
        if ($(".frblog-tab-main-wrapper").length > 0) {
          const itemsPerPage = 21; // Number of items per page
      
          $(".frblog-tab-content").each(function () {
            const $tabContent = $(this);
            const $cardsWrapper = $tabContent.find(".tab-cards-wrapper");
            const $cards = $tabContent.find(".tab-card-container");
            const $paginationContainer = $tabContent.find("#pagination");
            const $mainWrapper = $(".frblog-tab-main-wrapper"); // Main wrapper for scroll
            const $siteHeader = $("#SiteHeader"); // Header element
            let currentPage = 1;
      
            const totalCards = $cards.length;
            const totalPages = Math.ceil(totalCards / itemsPerPage);
      
            // Function to display data for the current page
            function displayData(page) {
              const start = (page - 1) * itemsPerPage;
              const end = start + itemsPerPage;
      
              $cards.hide();
              $cards.slice(start, end).show();
            }
      
            // Function to create pagination links
            function createPaginationLinks() {
              $paginationContainer.empty();
      
              // Add the Previous button
              $("<button>")
                .attr("class", "prevBtn")
                .prop("disabled", currentPage === 1)
                .on("click", function () {
                  if (currentPage > 1) {
                    currentPage--;
                    updatePagination();
                  }
                })
                .append(`
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-left" viewBox="0 0 284.49 498.98">
                    <path d="M249.49 0a35 35 0 0 1 24.75 59.75L84.49 249.49l189.75 189.74a35.002 35.002 0 1 1-49.5 49.5L10.25 274.24a35 35 0 0 1 0-49.5L224.74 10.25A34.89 34.89 0 0 1 249.49 0Z"></path>
                  </svg>
                `)
                .appendTo($paginationContainer);
      
              // Add page number links
              for (let page = 1; page <= totalPages; page++) {
                $("<span>")
                  .addClass("page")
                  .text(page)
                  .toggleClass("active", page === currentPage)
                  .on("click", function () {
                    currentPage = page;
                    updatePagination();
                  })
                  .appendTo($paginationContainer);
              }
      
              // Add the Next button
              $("<button>")
                .attr("class", "nextBtn")
                .prop("disabled", currentPage === totalPages)
                .on("click", function () {
                  if (currentPage < totalPages) {
                    currentPage++;
                    updatePagination();
                  }
                })
                .append(`
                  <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-chevron-right" viewBox="0 0 284.49 498.98"><title>icon-chevron</title><path d="M35 498.98a35 35 0 0 1-24.75-59.75l189.74-189.74L10.25 59.75a35.002 35.002 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L59.75 488.73A34.89 34.89 0 0 1 35 498.98Z"></path></svg>
                `)
                .appendTo($paginationContainer);
            }
      
            // Function to update the pagination state
            function updatePagination() {
              displayData(currentPage);
      
              // Calculate offset excluding the header height and adding 20px
              const headerHeight = $siteHeader.outerHeight() || 0;
              const scrollToPosition = $mainWrapper.offset().top - headerHeight - 20;
      
              // Scroll to the main wrapper section
              $("html, body").animate(
                { scrollTop: scrollToPosition },
                500 // Animation duration in milliseconds
              );
      
              // Update button states
              $paginationContainer.find(".prevBtn").prop("disabled", currentPage === 1);
              $paginationContainer.find(".nextBtn").prop("disabled", currentPage === totalPages);
      
              // Update active class on page links
              $paginationContainer.find(".page")
                .removeClass("active")
                .eq(currentPage - 1)
                .addClass("active");
            }
      
            // Initialize for this tab content
            displayData(currentPage);
            createPaginationLinks();
          });
        }

        if ($('a').length > 0) {
            $('a').each(function () {
                // Get the href attribute of the link
                var href = $(this).attr('href');
                
                // Check if the href is defined and is an external link
                if (href && !href.startsWith(window.location.origin) && !href.startsWith('/') && !href.startsWith('#')) {
                    // Add the target="_blank" attribute
                    $(this).attr('target', '_blank');
                }
            });
        }
      
    });

      var sub_slider = new Swiper(".sub-slider", {
        slidesPerView: 1,
        spaceBetween: 15,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    
    //smoothscroll
    $('a[href^= "#"]:not(".jdgm-write-rev-link")').on('click', function (x) {
        var header_top = 0;
        var header_bottom = 0;
        var header_outer_height = 0;
        if ($('#shopify-section-sections--23725458784574__header').length) {
            header_top = $('#shopify-section-sections--23725458784574__header').height();
        }
        if ($('#shopify-section-sections--23725458784574__announcement').length) {
            header_top = $('#shopify-section-sections--23725458784574__announcement').height();
        }
        var header_outer_height = header_top + header_bottom
        x.stopImmediatePropagation();
        x.preventDefault();
        $(document).off("scroll");
        // target element id
        var id = $(this).attr('href');
        // target element
        var $id = $(id);
        if ($id.length === 0) {
            return;
        }
        // prevent standard hash navigation (avoid blinking in IE)
        x.preventDefault();
        // top position relative to the document
        var pos = $id.offset().top - header_outer_height;
        // animated top scrolling
        $('body, html').animate({ scrollTop: pos });
    });
    // Text link
    $('.text-link .btn').html(function () {
        // get the full text
        var text = $(this).text().trim().split(' ');
        // drop the last word and store it in a variable
        var last = (text.pop()).trim();
        // if the text array is empty (i.e., only one word was present), return only the last word wrapped in a span
        return text.length > 0 ? text.join(" ") + ' <span class="last">' + last + '</span>' : '<span class="last">' + last + '</span>';
    });
    $(document).ready(function () {
      $('.char-block.skill-level .char-value').each(function () {
          let text = $(this).text(); // Get the text content
          let parts = text.split(':'); // Split at the colon
          if (parts.length > 1) {
              // Update the HTML with <strong> wrapping the first part and the colon after it
              $(this).html('<strong>' + parts[0].trim() + ':</strong>' + parts[1]);
          }
      });

      
        $('.footer-menu-col.important-links .sub-col:nth-child(4), .footer-menu-col.important-links .sub-col:nth-child(3)').remove();
        // $('.copyright-menu-list .menu-wrapper div:empty').remove();
        $('.footer-form-wrapper div[data-type="menu"], .footer-form-wrapper div[data-type="footer_menu"], .copyright-menu-list .menu-wrapper div:empty').remove();
        $(".burger_icon").click(function () {
            $(".custom-main-menu").slideToggle();
            $("body").toggleClass("open-main-menu");
        });
        $('.frblog-tab-main-wrapper').each(function () {
            var $section = $(this); // Cache the current section for use in the event handlers
            $section.find('.frblog-tabs-header .frblog-tab-button').on('click keydown', function (e) {
                if (e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) {
                    var index = $(this).index();
                    // Toggle active class on tab buttons
                    $section.find('.frblog-tab-button').removeClass('active');
                    $(this).addClass('active');
                    // Show the corresponding content and hide others
                    $section.find('.frblog-tabs-content-wrapper .frblog-tab-content').removeClass('active');
                    $section.find('.frblog-tabs-content-wrapper .frblog-tab-content').eq(index).addClass('active');
                }
            });
        });
    })
  
    $(document).on('click', '.custom-map-section .content-wrapper .button-wrpper .opne-map-link, a[href="/faq-popup"]', function (e) {
        e.preventDefault();
        $('.map-popup-wrapper').fadeIn().addClass('active');
    });
    $('body').on('click', '.map-popup-wrapper .map-popup-overlay, .map-popup-wrapper .close-icon', function () {
        $('.map-popup-wrapper').fadeOut().removeClass('active');
    });
    // Basic char-wrapper
    $('.basic-char-wrapper .cus-content-header').on('click', function () {
        if (window.matchMedia("(max-width: 768px)").matches) {
            $(this).find('.tab-button').toggleClass('active'); // Correctly toggle the class
            var $charBlocks = $(this).siblings('.cus-char-blocks');
            $charBlocks.slideToggle();
        }
    });
    // Advance char-wrapper
    $('.advance-char-wrapper .cus-content-header').on('click', function () {
        if (window.matchMedia("(max-width: 768px)").matches) {
            $(this).find('.tab-button').toggleClass('active'); // Correctly toggle the class
            var $charBlock = $(this).siblings('.char-block');
            $charBlock.slideToggle();
        }
    });

   

$(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
  if(ajaxSettings.url.includes('/api/form-submit') == true){
      $('html, body').animate({
        scrollTop: $('#shopify-section-template--23725458358590__advanced_content_4JYN4W').offset().top
      }, 500); // 1000ms = 1 second
  }
});


function handleTabs() {
    const isMobile = window.innerWidth <= 768;
    if (isMobile) {
        handleMobileTabs();
    } else {
        handleDesktopTabs();
    }
}

// function handleDesktopTabs() {
//   const tabs = document.querySelectorAll(".account-order-tab");
//   const contents = document.querySelectorAll(".tab-content");

//   function activateTab(tabName) {
//     tabs.forEach(t => t.classList.remove("active"));
//     contents.forEach(c => c.style.display = "none");

//     const activeTab = document.querySelector(`.account-order-tab[data-tab="${tabName}"]`);
//     const activeContent = document.getElementById(tabName);

//     if (activeTab) activeTab.classList.add("active");
//     if (activeContent) activeContent.style.display = "block";

//     // Update dropdown label if needed
//     const dropdownLabel = document.querySelector('.account-tabs-selected');
//     if (dropdownLabel && activeTab) {
//       dropdownLabel.textContent = activeTab.textContent;
//     }
//   }

//   // On click of a tab
//   tabs.forEach(tab => {
//   tab.addEventListener("click", function () {
//     const tabName = this.getAttribute("data-tab");

//     if (!tabName) return;
  
//     if (tabName === "upcoming-orders") {
//       window.location.href = "/pages/upcoming-orders";
//       return;
//     }
//     if (window.location.pathname.includes("/pages/upcoming-orders")) {
//       window.location.href = `/account?tab=${tabName}`;
//       return;
//     }

//     const newUrl = new URL(window.location);
//     newUrl.searchParams.set("tab", tabName);
//     window.history.replaceState({}, "", newUrl);

//     activateTab(tabName);
//   });
// });


//   // On page load — get tab from URL
//   const params = new URLSearchParams(window.location.search);
//   const initialTab = params.get("tab") || "order-history"; // default to order-history

//   // Only activate tab logic on /account (not on /pages/upcoming-orders)
//   if (window.location.pathname.includes("/account")) {
//     activateTab(initialTab);
//   }
// }

// start custom code
// document.addEventListener("DOMContentLoaded", () => {
//   const tabs = document.querySelectorAll(".account-order-tab, .account-tabs-dropdown-item");
//   const contents = document.querySelectorAll(".tab-content");
//   const dropdownLabel = document.querySelector(".account-tabs-selected");
  

//   const hideAllTabs = () => {
//     tabs.forEach(t => t.classList.remove("active"));
//     contents.forEach(c => c.style.display = "none");
//   };

//   const activateTab = (tabName) => {
//     if (!tabName) return;

//     hideAllTabs();

//     document.querySelectorAll(`[data-tab="${tabName}"]`).forEach(tab => tab.classList.add("active"));

//     const content = document.getElementById(tabName);
//     if (content) content.style.display = "block";

//     const firstTab = document.querySelector(`[data-tab="${tabName}"]`);
//     if (dropdownLabel && firstTab) dropdownLabel.textContent = firstTab.textContent.trim();
//   };

//   tabs.forEach(tab => {
//     tab.addEventListener("click", e => {
//       // console.log("working",tab)
//       e.preventDefault();
//       const tabName = tab.dataset.tab;
            
//       if (!tabName) return;

//       // if (tabName === "upcoming-orders") {
//       //   window.location.href = "/pages/upcoming-orders";
//       //   console.log("789");
//       //   return;
//       // }
//       // if (window.location.pathname.includes("/pages/upcoming-orders")) {
//       //   window.location.href = `/account?tab=${tabName}`;
//       //   return;
//       // }

//        if (tabName === "Log out") {
//         window.location.href = "/account/logout";
//         return;
//       }      

//       const url = new URL(window.location);
//       url.searchParams.set("tab", tabName);
//       window.history.replaceState({}, "", url);

//       activateTab(tabName);
//       if(__st.pageurl.includes('upcoming-order')){
//          window.location = `/account?tab=${tab.dataset.tab}`;
//       }
//     });
//   });

//   const params = new URLSearchParams(window.location.search);
//   const initialTab = params.get("tab") || "order-history";

//   if (window.location.pathname.includes("/account")) {
//     activateTab(initialTab);
//   }
// });


document.addEventListener("DOMContentLoaded", () => {
  const desktopTabs = document.querySelectorAll(".account-order-tab");
  const dropdownTabs = document.querySelectorAll(".account-tabs-dropdown-item");
  const allTabs = document.querySelectorAll(".account-order-tab, .account-tabs-dropdown-item");
  const contents = document.querySelectorAll(".tab-content");

  const dropdownLabel = document.querySelector(".account-tabs-selected");
  const dropdownList = document.querySelector(".account-tabs-dropdown-list");

  const hideAll = () => {
    allTabs.forEach(t => t.classList.remove("active"));
    contents.forEach(c => c.style.display = "none");
  };

  const activateTab = (tabName) => {
    hideAll();

    document.querySelectorAll(`[data-tab="${tabName}"]`).forEach(t =>
       {t.classList.add("active")
        
       });

    const content = document.getElementById(tabName);
    if (content) content.style.display = "block";

    const labelItem = document.querySelector(`.account-tabs-dropdown-item[data-tab="${tabName}"]`);
    if (labelItem) {
      dropdownLabel.childNodes[0].textContent = labelItem.textContent.trim() + " ";
    }
  };

  allTabs.forEach(tab => {
    tab.addEventListener("click", e => {
      e.preventDefault();
      const tabName = tab.dataset.tab;

      if (!tabName) return;

      // if (tabName === "upcoming-orders") {
      //   window.location.href = "/pages/upcoming-orders?tab=upcoming-orders";
      //   return;
      // }

      


      // if (window.location.pathname.includes("/pages/upcoming-orders")) {
      //   window.location.href = `/account?tab=${tabName}`;
      //   return;
      // }

      if (tabName === "Log out") {
        window.location.href = "/account/logout";
        return;
      }

      const url = new URL(window.location);
      url.searchParams.set("tab", tabName);
      window.history.replaceState({}, "", url);

      activateTab(tabName);
      dropdownList.classList.remove("open"); 
      if(tabName == 'account-details' && localStorage.getItem('birthday_day_selected_loyalty') == 'true'){
        let birthday_input_ele = document.querySelector('input.account-detail-date.birthday.dd_birthday_date_picker');
        if(birthday_input_ele){
          birthday_input_ele.value = loyaltylion.customer.birthday;
          birthday_input_ele.dispatchEvent(new Event('input'));
          localStorage.setItem('birthday_day_selected_loyalty',false);
          let atleast_one_date_found_text = document.querySelector('.atleast_one_date_found_text');
          if(atleast_one_date_found_text){
            let save_date_both_blank_general = document.querySelector('.save_date_both_blank_general');
            atleast_one_date_found_text.innerHTML = save_date_both_blank_general.innerHTML;
          }
        }
      }
    });
  });
  if(dropdownLabel){
  dropdownLabel.addEventListener("click", () => {
    dropdownList.classList.toggle("open");
  });
  }

  document.addEventListener("click", (e) => {
    if (dropdownLabel && !dropdownLabel.contains(e.target) && !dropdownList.contains(e.target)) {
      dropdownList.classList.remove("open");
    }
  });

  const params = new URLSearchParams(window.location.search);
  const initialTab = params.get("tab") || "upcoming-orders";
  activateTab(initialTab);
});


// end custom code





}(jQuery))

// Order page 
var productgrids = document.querySelectorAll(".product_list-grid .model-product-wrap");
if(productgrids.length){
  productgrids.forEach((productgrid)=>{
    var sizeOptions = productgrid.querySelectorAll(".pdp_size_variants .option_size");
    if(sizeOptions.length){
      sizeOptions.forEach((sizeOption)=>{
        sizeOption.addEventListener('click',function(){
          sizeOptions.forEach((element)=>{element.classList.remove('active');});
          this.classList.add('active');
          var data_id = this.getAttribute("data-variant-id");
          var button = productgrid.querySelector(".card_edit_btn");
          button.setAttribute("data_var_id",data_id);
          var price = this.getAttribute("data-price");
          productgrid.querySelector(".pdp_price").textContent = price;
        })
      })
    }
  })
}

document.addEventListener('DOMContentLoaded', function () {
  const firstTabBtn = document.querySelector('.first_tab_btn');
  const secondTabBtn = document.querySelector('.second_tab_btn');
  const oneTimeOrders = document.querySelector('#order-history');
  const subscriptionContent = document.querySelector('.subscription-content');
  const $container = document.querySelector("#subscriptionContainer");

  if (!firstTabBtn || !secondTabBtn || !oneTimeOrders || !subscriptionContent || !$container) {
    console.warn("One or more tab-related elements are missing from the DOM.");
    return; // Stop script if any required element is missing
  }

  firstTabBtn.addEventListener('click', function (e) {
    e.preventDefault();
    oneTimeOrders.style.display = 'block';
    subscriptionContent.style.display = 'none';

    firstTabBtn.classList.add('active');
    secondTabBtn.classList.remove('active');
  });

  secondTabBtn.addEventListener('click', function (e) {
    e.preventDefault();
    

    oneTimeOrders.style.display = 'none';
    subscriptionContent.style.display = 'block';

    secondTabBtn.classList.add('active');
    firstTabBtn.classList.remove('active');

    $container.innerHTML = "";
    $container.classList.add("loading");

    if (typeof refreshData === "function") {
      refreshData();
    } else {
      console.warn("refreshData function is not defined.");
    }
  });

  // Set One-Time Orders as default
  oneTimeOrders.style.display = 'block';
  subscriptionContent.style.display = 'none';
  firstTabBtn.classList.add('active');
  secondTabBtn.classList.remove('active');
});


document.addEventListener('giftship.datepicker.updated', function (event) {
  if (event.detail.element.name === "attributes[Bouquets-datepicker]") {
    const dateStr = event.detail.dateStr;
    const date = new Date(dateStr);
    const isSaturday = date.getDay() === 6;

    const input = document.querySelector('input[name="attributes[Bouquets-datepicker]"]');
    const existingMessage = document.querySelector(".charge-message");
    const parentContainer = input?.closest('.gs__option-input-wrap.gs__field.gs__align-left');

    // Show or remove Saturday delivery message
    if (isSaturday) {
      if (!existingMessage && parentContainer) {
        const message = document.createElement("div");
        message.classList.add("charge-message");
        message.textContent = "An additional shipping charge will be applied at checkout for Saturday delivery.";
        parentContainer.insertAdjacentElement("afterend", message);
      }
    } else if (existingMessage) {
      existingMessage.remove();
    }
  }
});




document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.querySelector('button[name="checkout"]');
  
  if (checkoutButton) {
    checkoutButton.addEventListener('click', function () {
      let bouquetsDateValue = $('input[name="attributes[Bouquets-datepicker]"]');
      const $pottedInput = $('input[name="attributes[potted-datepicker]"]');
      
      const bouquetsVisible = bouquetsDateValue.is(':visible');
      const pottedVisible = $pottedInput.is(':visible');
      
      const bouquetsValue = bouquetsDateValue.val().trim();
      const pottedValue = $pottedInput.val().trim();
      
      // Case 1: Both fields are visible, at least one is empty
      if (bouquetsVisible && pottedVisible) {
        if (!bouquetsValue || !pottedValue) {
          // alert('Please select both delivery dates to proceed.');
          return false;
        }
      }
      
      // Case 2: Only potted input is visible
      if (!bouquetsVisible && pottedVisible && !pottedValue) {
        // alert('Please select the potted delivery date.');
        return false;
      }
      
      // Case 3: Only bouquets input is visible
      if (!pottedVisible && bouquetsVisible && !bouquetsValue) {
        // alert('Please select the bouquets delivery date.');
        return false;
      }
      
      
      if (bouquetsValue) {
        // event.preventDefault();
        
        checkoutButton.classList.add('btn--loading');
        const date = new Date(bouquetsValue); // Format must be yyyy-mm-dd
        const isSaturday = date.getDay() === 6;
        fetch(window.Shopify.routes.root + 'cart.js')
        .then(response => response.json())
        .then(cart => {
          const productId = 51660936282430;
          const chargeItem = cart.items.find(item => item.variant_id === productId);
          
          const bouquetItems = cart.items.filter(item => item.product_type?.toLowerCase() === 'bouquets');
          let totalStems = 0;
          bouquetItems.forEach(item => {
            const sizeOption = item.options_with_values.find(opt => opt.name.toLowerCase() === 'size');
            let stems = 0;
            if (sizeOption) {
              const match = sizeOption.value.match(/\d+/);
              if (match) {
                stems = parseInt(match[0], 10);
              }
            }
            if (stems === 0) {
              stems = 24;
            }
          
            totalStems += stems * item.quantity;
          });

          

          let requiredQty = 0;
          if(bouquetItems.length > 0){
            
            if (isSaturday) {
              if (totalStems <= 24) requiredQty = 1;
              else if (totalStems <= 48) requiredQty = 2;
              else if (totalStems <= 72) requiredQty = 3;
              else requiredQty = 4;

              if (!chargeItem) {
                // Add charge item with requiredQty
                return fetch(window.Shopify.routes.root + 'cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ items: [{ id: productId, quantity: requiredQty }] })
                });
              } else {
                if (chargeItem.quantity !== requiredQty){
                  // Update existing charge item
                  return fetch(window.Shopify.routes.root + 'cart/change.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: chargeItem.key, quantity: requiredQty })
                  });
                }
              }
            } else {
               if(chargeItem){
                // Not Saturday: remove charge item if present
                return fetch(window.Shopify.routes.root + 'cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: chargeItem.key, quantity: 0 })
                });
               }
            }
          }
          
          // No change needed
          // return Promise.resolve();
        })
        .then(() => {
          // Ensure cart is up to date before redirect
          return fetch(window.Shopify.routes.root + 'cart.js');
        })
        .then(() => {
          document.dispatchEvent(new CustomEvent('cart:build'));
          window.location.href = '/checkout';
        })
        .catch(error => {
          checkoutButton.classList.remove('btn--loading');
          console.error('Error processing cart:', error);
          // window.location.href = '/checkout'; // Fallback redirect
        });
      }
      // else{
      //   window.location.href = '/checkout';
      // }
    });
  }
});





const cookieSettings = document.getElementById("Cookie Settings");

if (cookieSettings) {
    cookieSettings.addEventListener("click", function(e) {
        e.preventDefault(); // Prevent the default behavior of the link

        if (typeof Cookiebot !== "undefined" && typeof Cookiebot.show === "function") {
            Cookiebot.show(); // Open the Cookiebot settings dialog
        } else {
            console.error("Cookiebot is not available or the show function is not defined.");
        }
    });
}


  const variantWrapper = document.querySelector(".variant-wrapper");
  const appContainer = document.querySelector(".gs__app-container");

  if (variantWrapper && appContainer) {
    variantWrapper.insertAdjacentElement("afterend", appContainer);
  }